<template>
  <div id="app">
    <nav>
      <div style="height: 100%;display: flex;align-items: center;">
        <img :src="zh_en == 'zh' ? STATICURL + configs.logo : STATICURL + configs.logo_en"
          style="width: 57px;height: 57px;" alt="">
        <div style="text-align: justify;text-align-last: justify;margin: 0 50px 0 20px;color: #8A2E26;font-size: 24px;">
          {{ configs.company }} <br>
          <span style="font-size: 12px;"> {{ configs.company_en }}</span>
        </div>
      </div>
      <div v-for="(item, index) in tabList" :key="index" class="navBox">
        <router-link :to="item.url" v-if="item.url != '/develop'">{{ item.name }}</router-link>
      </div>


      <div style="margin-left: 50px;">
        <el-switch style="display: block" v-model="zh_en" active-color="#13ce66" inactive-color="#ff4949"
          @change="changezhen" active-text="简体中文" inactive-text="english">
        </el-switch>
      </div>
    </nav>
    <router-view />
  </div>
</template>

<script>
import { get_bgimg, get_configs } from '@/api/api'
import Vue from 'vue'
export default {
  data() {
    return {
      zh_en: '',
      tabList: [],
      configs: {}
    }
  },
  beforeCreate() {
    if (localStorage.getItem('zh_en') != 'en' && localStorage.getItem('zh_en') != 'zh') {
      localStorage.setItem('zh_en', 'zh')
    }
    get_bgimg().then(res => {
        localStorage.setItem('bgimg', res);
        Vue.prototype.bgimg = res;
      })
  },
  mounted() {
    console.log('-------------------------------------------');
    this.tabList = [{
      name: localStorage.getItem('zh_en') != 'en'? '首页' : 'Home',
      url: '/'
    },
    {
      name: localStorage.getItem('zh_en') != 'en'? '品牌文化' : 'Culture',
      url: '/culture'
    },
    {
      name: localStorage.getItem('zh_en') != 'en'? '企业动态' : 'Company',
      url: '/company'
    },
    {
      name: localStorage.getItem('zh_en') != 'en'? '产品介绍' : 'Products',
      url: '/shop'
    },
    {
      name: localStorage.getItem('zh_en') != 'en'? '溯源开发' : 'Develop',
      url: '/develop'
    },
    {
      name: localStorage.getItem('zh_en') != 'en'? '商务合作' : ' Cooperation',
      url: '/work'
    },
    {
      name: localStorage.getItem('zh_en') != 'en'? '联系我们' : 'Contact',
      url: '/talk'
    }],
    
    this.zh_en = localStorage.getItem('zh_en') == 'en' ? false : true
    get_configs().then(res => {
      this.configs = res
    })
  },
  methods: {
    changezhen(e) {
      console.log(e);
      let zh_en = e ? 'zh' : 'en'
      localStorage.setItem('zh_en', zh_en)
      location.reload()
    }
  }
}

</script>
<style>
* {
  margin: 0;
  padding: 0;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  height: 12vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  background-color: #fff;
  z-index: 999;
}

.navBox {
  padding: 0 10px;

}

nav a {
  font-weight: bold;
  color: #2c3e50;
  font-size: 20px;
  padding: 20px 0;
  margin: 0 10px;
  font-weight: normal;
  text-decoration: none;
}



nav a.router-link-exact-active {
  color: #8A2E26;
  font-weight: 600;
  border-bottom: 2px solid #8A2E26;
}
</style>
